import { Dispatcher } from "flux";

class DispatcherClass extends Dispatcher
{
	handleAction(action)
	{
		this.dispatch(action);
	}
}

const AppDispatcher = new DispatcherClass();

export default AppDispatcher;



// WEBPACK FOOTER //
// ./Components/dispatcher/AppDispatcher.jsx